import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'

import { FootPrintPortalManager_materials_by_base_packaging_gridComponent } from './FootPrintPortalManager.materials_by_base_packaging_grid.component';
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Materials_materials_by_project_dd_multiComponent } from './Materials.materials_by_project_dd_multi.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootPrintPortalManager_materials_by_base_packaging_gridComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Materials_materials_by_project_dd_multiComponent),
  ],
  selector: 'FootPrintPortalManager-materials_hub',
  templateUrl: './FootPrintPortalManager.materials_hub.component.html'
})
export class FootPrintPortalManager_materials_hubComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { ownerId?: number, projectId?: number } = { ownerId: null, projectId: null };
  //#region Inputs
  @Input('ownerId') set $inParams_ownerId(v: number) {
    this.inParams.ownerId = v;
  }
  get $inParams_ownerId(): number {
    return this.inParams.ownerId;
  }
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    owner: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    materials: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      create_material: new ToolModel(new ButtonModel('create_material', new ButtonStyles(null, null), false, 'Create material', 'ms-Icon ms-Icon--Add')
    ),
      manage_project: new ToolModel(new ButtonModel('manage_project', new ButtonStyles(null, null), false, 'Manage project', 'ms-Icon ms-Icon--Settings')
    )
  };

  actionbar = {
  };

 filters = {
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Owner', true)
,
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Project', false)
,
    materials: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['materials'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Materials', false)
,
  };


  filtersets = {
  newGroup1: new FieldsetModel('Filters', false, true, false),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      materials: new TabItemModel(
        this.rootTabGroup, 
        'Materials', 
        ),
    };
  
    //#region tabs inParams
    get $tabs_materials_materials_by_base_packaging_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_materials_materials_by_base_packaging_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_materials_materials_by_base_packaging_grid_inParams_materialIds: number[];
    get $tabs_materials_materials_by_base_packaging_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_materials_materials_by_base_packaging_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_materials_materials_by_base_packaging_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_materials_materials_by_base_packaging_grid_inParams_materialIds;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_materials', { read: FootPrintPortalManager_materials_by_base_packaging_gridComponent }) $tabs_materials: FootPrintPortalManager_materials_by_base_packaging_gridComponent;
    //#endregion tabs children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  get $fields_materials_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Materials hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Your landing page to view materials across your projects and assigned warehouses.`;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: FootPrintPortalManager_ShellService,
  private datasources: FootPrintPortalManager_DatasourceService,
  private flows: FootPrintPortalManager_FlowService,
  private reports: FootPrintPortalManager_ReportService,
  private localization: FootPrintPortalManager_LocalizationService,
  private operations: FootPrintPortalManager_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.materials,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Materials Hub';
    
    const $hub = this;
    const $utils = this.utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['owner']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_change();
      });
    this.formGroup
      .controls['project']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_materials') {
      if (!isNil(this.$tabs_materials) && !this.tabs.materials.hidden) {
        this.$tabs_materials.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_create_material_clicked(event = null) {
    return this.on_create_material_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_material_clickedInternal(
    $hub: FootPrintPortalManager_materials_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  const dialogResult = (await $shell.FootPrintPortalManager.openmaterial_creation_formDialog({
      ownerId: $hub.filters.owner.control.value,
      projectId: $hub.filters.project.control.value
      }));
  const userConfirm = dialogResult.confirm;
  if (userConfirm){
      await $hub.refresh();
  }
  }
  on_owner_change(event = null) {
    return this.on_owner_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changeInternal(
    $hub: FootPrintPortalManager_materials_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  $hub.filters.project.control.value = null;
  }
  on_project_change(event = null) {
    return this.on_project_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changeInternal(
    $hub: FootPrintPortalManager_materials_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const projectId = $hub.filters.project.control.value
  
  
  // Set Owner from Project
  if ($utils.isDefined(projectId) && !$utils.isDefined($hub.filters.owner.control.value)) {
      const project = (await $datasources.Materials.ds_get_project_by_projectId.get({
          projectId: projectId
      })).result;
     
      if ($utils.isDefined(project)) {
  
          $hub.filters.owner.control.value = project[0].OwnerId;
  
      }
  
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootPrintPortalManager_materials_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($hub.inParams.ownerId) || $utils.isDefined($hub.inParams.projectId)){
      $hub.filters.owner.control.value = $hub.inParams.ownerId
      $hub.filters.project.control.value = $hub.inParams.projectId
  }
  else {
  
      // Default to the first owner and project based on the users data access role
      const project = (await $datasources.Owners.ds_get_project_top1.get({})).result;
      if ($utils.isDefined(project)) {
  
          const projectId = project.Id;
          const ownerId = project.OwnerId;
  
          if ($utils.isAllDefined(projectId, ownerId)) {
              $hub.filters.project.control.value = projectId;
              $hub.filters.owner.control.value = ownerId;
          }
      }
  
  }
  
  
  //Apply operations
  await $hub.on_apply_operations();
  }
  on_manage_project(event = null) {
    return this.on_manage_projectInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_manage_projectInternal(
    $hub: FootPrintPortalManager_materials_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($hub.filters.project.control.value)) {
      await $shell.FootPrintPortalManager.opensingle_project_hub({
          projectId: $hub.filters.project.control.value,
          ownerId: $hub.filters.owner.control.value
      });
  
  }
  else {
      $shell.FootPrintPortalManager.openInfoDialog('Manage project', 'Please select a project filter first.')
  }
  }
  on_apply_operations(event = null) {
    return this.on_apply_operationsInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_apply_operationsInternal(
    $hub: FootPrintPortalManager_materials_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Apply operations
  if (await $operations.FootPrintPortalManager.Disable_Materials_Hub.isAuthorized()){
      $hub.close();
      $shell.FootPrintPortalManager.openErrorDialog('Authorization','You are not authorized to access the materials hub.');
      
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Material_Creation.isAuthorized()){
      $hub.toolbar.create_material.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Project_Management.isAuthorized()){
      $hub.toolbar.manage_project.hidden = true;
  }
  }
  //#endregion private flows
}
